import React, { useEffect, useState } from "react";
import styles from "./detailBloodStationTop.module.scss";
import { observer } from "mobx-react";
import Spinner from "../../spinner";
import CustomCarousel from "../../ui/customCarousel";
import TopDonorCard from "../../topDonor/topDonorCard";
import { useStores } from "../../../hooks/mobx";
import BlockContainer from "../../mainPageBlocks/blockContainer";

type TDetailBloodStationTop = {
  id: string | number;
};

const DetailBloodStationTop: React.FC<TDetailBloodStationTop> = observer(
  ({ id }) => {
    const responsive = {
      superLargeDesktop: {
        breakpoint: { max: 3000, min: 1920 },
        items: 5,
        slidesToSlide: 5,
        partialVisibilityGutter: 40,
      },
      desktop: {
        breakpoint: { max: 1919, min: 1440 },
        items: 5,
        slidesToSlide: 5,
        partialVisibilityGutter: 20,
      },
      laptop: {
        breakpoint: { max: 1439, min: 1200 },
        items: 4,
        slidesToSlide: 4,
        partialVisibilityGutter: 20,
      },
      tablet: {
        breakpoint: { max: 1199, min: 768 },
        items: 2,
        slidesToSlide: 2,
        partialVisibilityGutter: 70,
      },
      mobile: {
        breakpoint: { max: 767, min: 360 },
        items: 1,
        slidesToSlide: 1,
        partialVisibilityGutter: 60,
      },
    };

    const { bloodStationsStore } = useStores();

    const [topCountAll, setTopCountAll] = useState([]);
    const [topCountYear, setTopCountYear] = useState([]);
    const [loader, setLoader] = useState(true);

    useEffect(() => {
      setLoader(true);
      Promise.all([
        bloodStationsStore
          .getTopUsersFromBS(id)
          .then((response) => setTopCountAll(response)),
        bloodStationsStore
          .getTopUsersFromBSHalfYear(id)
          .then((response) => setTopCountYear(response)),
      ])
        .then(() => setLoader(false))
        .catch(() => setLoader(false))
        .finally(() => setLoader(false));
    }, []);

    if (loader) return <Spinner toggled={true} />;

    if (!topCountAll.length && !topCountYear.length) return null;

    return (
      <div>
        {!!topCountYear.length && (
          <BlockContainer
            isGrid
            isBonus
            isSSR={true}
            title={"ТОП доноров с донациями за последние 12 месяцев"}
            linkText={"Смотреть всех"}
            linkUrl={`/top/?blood_station_id=${id}&by_year=true`}
          >
            <CustomCarousel
              removeArrowOnDeviceType={["mobile"]}
              removeDotsOnDeviceType={["mobile"]}
              swipeable={true}
              draggable={false}
              minimumTouchDrag={70}
              responsive={responsive}
              partialVisible={true}
              infinite={true}
            >
              {topCountYear.map((info) => (
                <div
                  className={styles.swiper_customElement}
                  key={`year_${info.id}`}
                >
                  <TopDonorCard info={info} notAgg />
                </div>
              ))}
            </CustomCarousel>
          </BlockContainer>
        )}
        {!!topCountAll.length && (
          <BlockContainer
            isGrid
            isBonus
            isSSR={true}
            title={"ТОП доноров за всё время"}
            linkText={"Смотреть всех"}
            linkUrl={`/top/?blood_station_id=${id}`}
          >
            <CustomCarousel
              removeArrowOnDeviceType={["mobile"]}
              removeDotsOnDeviceType={["mobile"]}
              swipeable={true}
              draggable={false}
              minimumTouchDrag={70}
              responsive={responsive}
              partialVisible={true}
              infinite={true}
            >
              {topCountAll.map((info) => (
                <div
                  className={styles.swiper_customElement}
                  key={`all_${info.id}`}
                >
                  <TopDonorCard info={info} notAgg />
                </div>
              ))}
            </CustomCarousel>
          </BlockContainer>
        )}
      </div>
    );
  }
);

export default DetailBloodStationTop;
